module.exports = __webpack_public_path__ + "img/1.1804c8a7.png";